<template>
    <div class="density">
        <div class="title">能耗密度</div>
        <div id="chart">
            <Charts id="chart1" :option="option1"/>
        </div>
        <div class="floot">
            <div class="flootItem">
                <!-- <span></span>0 <i class="el-icon-right"></i> {{maxValue * 0.25}} -->
                <span></span> 能耗低
            </div>
            <div class="flootItem">
                <!-- <span></span>{{maxValue * 0.25 + 1}} <i class="el-icon-right"></i> {{maxValue * 0.5}} -->
                <span></span> 低于平均值
            </div>
            <div class="flootItem">
                <!-- <span></span>{{maxValue * 0.5 + 1}} <i class="el-icon-right"></i> {{maxValue * 0.75}} -->
                <span></span> 高于平均值
            </div>
            <div class="flootItem">
                <!-- <span></span>{{maxValue * 0.75 + 1}} <i class="el-icon-right"></i> {{maxValue}} -->
                <span></span> 能耗高
            </div>
            <div class="flootItem">
                /kWh
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
import Charts from '../../../components/common/Charts.vue'
import { getProjecTypeEnergyConsumption } from '../../../api/power'
import { getLastOrNextFewDateBy, dayStart, getWeekDays, weekStart } from "../../../util/DateUtil";
export default {
    data(){
        return {
            currentFormatArr:[],
            maxValue:0,
            timer:null
        }
    },
    components:{
        Charts
    },
    computed:{
        option1(){
        return{
            tooltip: {
                position: 'top',
                // formatter:function(params){
                //     let date = params.name
                //     let data = params.data[2]
                //     return `<div style="font-size: 18rem;
                //             font-family: Source Han Sans CN;
                //             font-weight: bold;
                //             color: #333333;">${params.marker} ${date}: <span >${data} kWh</span></div>` 
                // }
                formatter: function (params) {
                    // console.log(params);
                    let str = `${parseInt(params.name) - 1}点-${parseInt(params.name) }点<br/>`;
                    str += `${params.marker}能耗： <b style='font-size:18px;'>${params.data[2]}</b><b style='font-size:14px;'> kWh</b>`;
                    
                    return str
                },
            },
            grid: {
                height: '85%',
                top: '0%',
                right:'4%',
                left:'2%'
            },
            xAxis: {
                type: 'category',
                data: [
                    '2点', '4点', '6点', '8点', '10点', '12点',
                    '14点', '16点', '18点', '20点', '22点', '24点',
                ],
                splitArea: {
                    show: true
                },
                axisLine:{
                    show:false
                },
                axisTick: {
                    show: false ,
                },
                boundarGap:true
            }, 
            yAxis: {
                type: 'category',
                data: [
                    '六', '五', '四',
                    '三', '二', '一', '日'
                ],
                splitArea: {
                    show: true
                },
                position:"right",
                axisLine:{
                    show:false,
                },
                axisTick: {
                    show: false ,
                },
            },
            visualMap: {
                min: 0,
                max: this.maxValue,
                calculable: true,
                orient: 'horizontal',
                left: 'center',
                bottom: '5%',
                show:false,
                inRange: {
                    color: ['#E6F8FF', '#0070D9'],
                    symbolSize: [30, 100]
                },
            },
            mytextStyle:{
                fontSize:30
            },
            series: [
                {
                    // name: 'Punch Card',
                    type: 'heatmap',
                    // data: [
                    //     [0, 0, 0], [0, 1, 1], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [0, 8, 0], [0, 9, 0], [0, 10, 0], [0, 11, 2], [0, 12, 4], [0, 13, 1], [0, 14, 1], [0, 15, 3], [0, 16, 4], [0, 17, 6], [0, 18, 4], [0, 19, 4], [0, 20, 3], [0, 21, 3], [0, 22, 2], [0, 23, 5], 
                    //     [1, 0, 7], [1, 1, 0], [1, 2, 0], [1, 3, 0], [1, 4, 0], [1, 5, 0], [1, 6, 0], [1, 7, 0], [1, 8, 0], [1, 9, 0], [1, 10, 5], [1, 11, 2], [1, 12, 2], [1, 13, 6], [1, 14, 9], [1, 15, 11], [1, 16, 6], [1, 17, 7], [1, 18, 8], [1, 19, 12], [1, 20, 5], [1, 21, 5], [1, 22, 7], [1, 23, 2], 
                    //     [2, 0, 1], [2, 1, 1], [2, 2, 0], [2, 3, 0], [2, 4, 0], [2, 5, 0], [2, 6, 0], [2, 7, 0], [2, 8, 0], [2, 9, 0], [2, 10, 3], [2, 11, 2], [2, 12, 1], [2, 13, 9], [2, 14, 8], [2, 15, 10], [2, 16, 6], [2, 17, 5], [2, 18, 5], [2, 19, 5], [2, 20, 7], [2, 21, 4], [2, 22, 2], [2, 23, 4], 
                    //     [3, 0, 7], [3, 1, 3], [3, 2, 0], [3, 3, 0], [3, 4, 0], [3, 5, 0], [3, 6, 0], [3, 7, 0], [3, 8, 1], [3, 9, 0], [3, 10, 5], [3, 11, 4], [3, 12, 7], [3, 13, 14], [3, 14, 13], [3, 15, 12], [3, 16, 9], [3, 17, 5], [3, 18, 5], [3, 19, 10], [3, 20, 6], [3, 21, 4], [3, 22, 4], [3, 23, 1], 
                    //     [4, 0, 1], [4, 1, 3], [4, 2, 0], [4, 3, 0], [4, 4, 0], [4, 5, 1], [4, 6, 0], [4, 7, 0], [4, 8, 0], [4, 9, 2], [4, 10, 4], [4, 11, 4], [4, 12, 2], [4, 13, 4], [4, 14, 4], [4, 15, 14], [4, 16, 12], [4, 17, 1], [4, 18, 8], [4, 19, 5], [4, 20, 3], [4, 21, 7], [4, 22, 3], [4, 23, 0], 
                    //     [5, 0, 2], [5, 1, 1], [5, 2, 0], [5, 3, 3], [5, 4, 0], [5, 5, 0], [5, 6, 0], [5, 7, 0], [5, 8, 2], [5, 9, 0], [5, 10, 4], [5, 11, 1], [5, 12, 5], [5, 13, 10], [5, 14, 5], [5, 15, 7], [5, 16, 11], [5, 17, 6], [5, 18, 0], [5, 19, 5], [5, 20, 3], [5, 21, 4], [5, 22, 2], [5, 23, 0], 
                    //     [6, 0, 1], [6, 1, 0], [6, 2, 0], [6, 3, 0], [6, 4, 0], [6, 5, 0], [6, 6, 0], [6, 7, 0], [6, 8, 0], [6, 9, 0], [6, 10, 1], [6, 11, 0], [6, 12, 2], [6, 13, 1], [6, 14, 3], [6, 15, 4], [6, 16, 0], [6, 17, 0], [6, 18, 0], [6, 19, 0], [6, 20, 1], [6, 21, 2], [6, 22, 2], [6, 23, 6]]
                    //     .map(function (item) {
                    //     return [item[1], item[0], item[2] || '-'];
                    // }),
                    data:this.currentFormatArr,
                    label: {
                        show: false
                    },
                    emphasis: {
                        itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    itemStyle:{
                        borderWidth:2,
                        borderColor:'#fff'
                    }
                }
            ]
        }
            
        }
    },
    mounted(){
        let _this = this
        this.getEnergyDiargm()
        this.timer = setInterval(()=>{
			_this.getEnergyDiargm()
		}, 7200 * 1000)
    },
    destroyed(){
		if(this.timer){
			clearInterval(this.timer)
			this.timer = null
		}
	},
    methods:{
        async getEnergyDiargm(){
            let _this = this
            let today = dayStart(new Date())
            let time = getWeekDays()
            // time.push(time.shift())
            // console.log(time);
            let idx = time.findIndex(item =>today == today.split('-')[0] + '-' + item)

            try{
                let promiseArr = time.map((item,index) =>{
                    if(index > idx){
                        return item = getProjecTypeEnergyConsumption({
                            date:(Number(today.split('-')[0]) + 1) + '-' + item,
                            powerType:'ELECTRICITY',
                            projectId:_this.$store.state.project.currentProject.projectId,
                            range:'DAY'
                        })
                    }else{
                        return item = getProjecTypeEnergyConsumption({
                            date:today.split('-')[0] + '-' + item,
                            powerType:'ELECTRICITY',
                            projectId:_this.$store.state.project.currentProject.projectId,
                            range:'DAY'
                        })
                    }
                    
                })
                let formatArr = []
                let res = await Promise.all(promiseArr)
                console.log(res);
                res.reverse().forEach((item,index) =>{
                    let result2 = item.data.data.result.electricity.filter((content,even) => even %2 !== 0)
                    let result1 = item.data.data.result.electricity.filter((content,even) => even %2 == 0)
                    
                    // console.log(result1);
                    // console.log(result2);
                    let result = result2.map((item3,index3) =>{
                        return item3 = item3 ==null && result1[index3] ==null?null:item3 + result1[index3]
                    }).map((item2, idx2) =>{
                        return item = [ idx2,index, item2 == null?null:parseInt(item2)]
                    })
                    // console.log(result);
                    formatArr = formatArr.concat(result)
                })
                
                this.currentFormatArr = formatArr


                let arr = formatArr.sort((a , b)=>{
                    return  b[2] - a[2] 
                })
                this.maxValue = Math.ceil(arr[0][2] / 100) *100
                // console.log(this.maxValue);
				
            }catch(err){
                console.log(err);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.density{
    .h(320);
    .w(592);
    background: #FFFFFF;
    padding: 0 16rem;
    .title{
        height: 45rem;
        line-height: 45rem;
        font-size: 16rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
    }
    #chart{
        width: 100%;
        height: 21vh;
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    }
    .floot{
        height: 45rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .flootItem{
            font-size: 14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            &>span{
                display: inline-block;
                width: 32rem;
                height: 12rem;
                background: #E6F8FF;
                border-radius: 2rem;
                margin-right:8rem ;
            }
        }
        .flootItem:nth-child(2){
            &>span{
                background: #87D5FF;
            }
        }
        .flootItem:nth-child(3){
            &>span{
                background: #36ABFF;
            }
        }
        .flootItem:nth-child(4){
            &>span{
                background: #0070D9;
            }
        }
        .flootItem:last-child{
            color: #333;
            font-weight: bold;
        }
    }
}
</style>